module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_vm._v("\n  Unable to fetch tags data.\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /home/abuild/rpmbuild/BUILD/Portus-master/~/vue-loader/lib/template-compiler?{"id":"data-v-2c8dfc72"}!/home/abuild/rpmbuild/BUILD/Portus-master/~/vue-loader/lib/selector.js?type=template&index=0!./modules/repositories/components/tags-not-loaded.vue
// module id = 84
// module chunks = 0